import { render, staticRenderFns } from "./Rdw.vue?vue&type=template&id=59dc3a55&"
import script from "./Rdw.vue?vue&type=script&lang=js&"
export * from "./Rdw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports